import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { ButtonWrapper as i, TextWrapper as l, LoadingSpinner as m } from "./styled.js";
const f = ({
  disabled: o,
  children: n,
  buttonType: r = "primary",
  onClick: p = () => {
  },
  isLoading: e = !1,
  ...a
}) => /* @__PURE__ */ s(
  i,
  {
    disabled: o || e,
    $buttonType: r,
    onClick: p,
    ...a,
    children: [
      /* @__PURE__ */ t(l, { role: "none", $buttonType: r, children: n }),
      e && /* @__PURE__ */ t(m, {})
    ]
  }
);
export {
  f as Button,
  f as default
};
